module.exports = "<div class=\"portlet-area\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <ea-message-form-portlet message-id=\"$ctrl.messageId\"></ea-message-form-portlet>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaMessage/eaMessageInbox/eaMessageDetailPage/eaMessageDetailPage.tpl.html
// module id = 1029
// module chunks = 12